<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0 pl-2" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content">
				<v-row class="ma-0 pa-0" align="center" id="header_height">
					<router-link :to="{ path: '/setting' }" style="color:transparent;">
						<v-col class="ma-0 pa-0" cols="auto" align="center"
							style="color:#08B0FF;font-size:1rem;text-align:center;">
							{{ ts('title') }}
						</v-col>
					</router-link>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<router-link :to="{ path: '/setting/authority' }" style="color:transparent;">
						<v-col class="ma-0 pa-0" cols="auto" align="center"
							style="color:#08B0FF;font-size:1rem;text-align:center;">
							{{ ts('shareUserPermissionSettings') }}
						</v-col>
					</router-link>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<v-col class="ma-0 pa-0" cols="auto">
						{{ ts('mappingCameraGroup') }}
					</v-col>
				</v-row>
			</v-col>
		</v-col>
		<v-col class="pa-0" id="main_content" cols="12" align="center">
			<v-col class="ma-0 pa-0 pt-9 mb-15" cols="10" align="left">
				<div style="position: relative;">
				<v-data-table :items="records" :items-per-page="itemsPerPage" fixed-header height="70vh"
					class="elevation-1 fixed-table" dark :footer-props="{ itemsPerPageOptions: [10, 50, 100, 500, -1] }">
					<template v-slot:header="{}">
						<thead>
							<tr>
								<th v-for="header in headers" :key="header.value"
									:class="header.value === 'userName' ? 'sticky-column' : ''">
									{{ header.text }}
								</th>
							</tr>
						</thead>
					</template>
					<template v-slot:item="{ item }">
						<tr>
							<td class="sticky-column">
								<v-row class="pl-2">{{ item.userName }}</v-row>
								<v-row class="pl-2">{{ item.name }}</v-row>
							</td>
							<td v-for="(value, key) in item.cameraGroups" :key="key">
								<v-switch :input-value="value" @change="toggleCameraGroup(item, key)" light></v-switch>
							</td>
						</tr>
					</template>
				</v-data-table>
					<div v-if="dataLoading" class="table_loading_overlay">
						<v-progress-circular indeterminate color="white" :width="4" :size="40"></v-progress-circular>
					</div>
				</div>
				<v-row align="center" justify="end">
					<v-btn width="auto" height="2rem" id="blue_btn" :loading="saveLoading"
						class="blue_btn ma-0 pa-0 mt-10 mr-3" elevation="0" @click="save()">
						{{ t('save') }}
					</v-btn>
				</v-row>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';

export default {
	mixins: [mixin.common],
	data: () => ({
		headers: [],
		records: [],
		users: {},
		mappings: {},
		initData: [],
		itemsPerPage: 100,
		dataLoading: false,
		saveLoading: false,
		updateIds: []
	}),
	mounted() {
		// 세로 열: 등록된 사용자(일반 사용자, 시청자), 가로 열: 카메라 그룹
		this.setData();
	},
	methods: {
		ts(t) {
			return this.$t("lang.settings." + t);
		},
		tc(t) {
			return this.$t("lang.common." + t);
		},
		async setData() {
			this.dataLoading = true;
			const usersRes = await this.networkController.getShareUser({});
			const mappingRes = await this.networkController.getBatchSharedUserCameraGroup({});
			this.users = usersRes.data.accounts;
			this.mappings = mappingRes.data;

			this.setHeader();
			this.setMapping();
			this.dataLoading = false;
		},
		setHeader() {
			this.headers = [{ text: this.tc('userId'), value: 'userName', sortable: true, width: '6rem' }];
			this.mappings.forEach(item => {
				this.headers.push({
					text: item.groupName,
					value: `cameraGroups.${item.id}`,
					sortable: false,
				});
			});
		},
		setMapping() {
			const initCameraGroupMap = {};
			this.mappings.forEach(item => {
				initCameraGroupMap[item.id] = false;
			});
			this.users.forEach(user => {
				const record = {
					userName: user.userName,
					name: user.name,
					mailAddress: user.mailAddress,
					umid: user.umid,
					cameraGroups: { ...initCameraGroupMap }
				};
				// 카메라그룹 매핑은 일반사용자와 뷰어만 가능 (점포그룹과 동일)
				if (this.isUserOrViewer(user.role)) {
					this.records.push(record);
				}
			});
			this.setUserCameraGroup();
			this.initData = JSON.parse(JSON.stringify(this.records));
		},
		setUserCameraGroup() {
			this.mappings.forEach(item => {
				if ((item.sharedUserCameraGroups || []).length > 0) {
					item.sharedUserCameraGroups.forEach(cameraGroup => {
						const userRecord = this.records.find(record => record.umid === cameraGroup.umid);
						if (userRecord) {
							userRecord.cameraGroups[item.id] = true;
						}
					});
				}
			});
		},
		toggleCameraGroup(item, key) {
			item.cameraGroups[key] = !item.cameraGroups[key];
			this.updateIds.push(item.umid);
		},
		save() {
			this.saveLoading = true;

			const updateMap = {};
			const deleteIds = [];
			const sharedUserCameraGroups = [];
			const updateList = this.records.filter(record => Array.from(new Set(this.updateIds)).includes(record.umid));
			updateList.forEach(record => {
				const initRecord = this.initData.find(initRecord => initRecord.umid === record.umid);
				if (initRecord) {
					Object.keys(record.cameraGroups).forEach(key => {
						if (record.cameraGroups[key] !== initRecord.cameraGroups[key]) {
							if (record.cameraGroups[key]) {
								sharedUserCameraGroups.push({
									name: record.name,
									mailAddress: record.mailAddress,
									umid: record.umid,
									cameraGroupId: key
								});
							} else {
								this.mappings.find(item => item.id === key).sharedUserCameraGroups.forEach(cameraGroup => {
									if (cameraGroup.umid === record.umid) {
										deleteIds.push(cameraGroup.id);
									}
								});
							}
						}
					});
				}
			});

			updateMap.deleteIds = deleteIds;
			updateMap.sharedUserCameraGroups = sharedUserCameraGroups;
			this.networkController.postBatchSharedUserCameraGroup(updateMap);

			this.saveLoading = false;

			this.$dialog.confirm({
				text: this.ts('registerCompleted'),
				actions: {
					true: {
						color: 'white', text: this.t('confirm'),
						handle: () => {
							this.$router.push({ path: '/setting/authority' });
						}
					}
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
#header_text {
	font-size: 1.5rem;
	text-align: left;
}
#header_divider {
	border: 1px solid rgb(141, 141, 141);
}
.blue_btn {
	background-color: #008DD0 !important;
	color: white;
	border-radius: 4px;
	min-width: 6rem !important;
}
.custom-scrollbar ::-webkit-scrollbar {
	height: 3px;
}
.custom-scrollbar ::-webkit-scrollbar-thumb {
	background-color: white;
}
.custom-scrollbar ::-webkit-scrollbar-track {
	background-color: #4A4A4A;
}
::v-deep .v-data-table__wrapper tbody tr {
	background-color: inherit !important;
}
::v-deep .v-data-table__wrapper tbody tr:hover {
	background-color: inherit !important;
}
.fixed-table .v-data-table__wrapper {
	overflow-x: auto;
}
.fixed-table thead th {
	position: sticky;
	top: 0;
	background-color: #1E1E1E;
	z-index: 2;
}
.fixed-table tbody td.sticky-column {
	position: sticky;
	left: 0;
	background-color: #1E1E1E;
	z-index: 3;
}
.fixed-table thead th.sticky-column {
	position: sticky;
	left: 0;
	background-color: #1E1E1E;
	z-index: 4;
}
.table_loading_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(30, 30, 30, 0.35);
  z-index: 5;
}
</style>
